<script setup>
import { ref, computed } from "vue";
import IModal from '../IModal/IModal.vue';

const props = defineProps({
    isPushkinPurchaseEnable: {
        type: Boolean,
        required: true,
    }
})

const emit = defineEmits(['closePushkinWarningModal', 'continiueBuy'])

const isModalShow = defineModel();

const continiueButtonClass = computed(() => props.isPushkinPurchaseEnable ? '' : 'i-acquirings-button_disabled')

</script>

<template>
    <IModal
        v-model="isModalShow"
        class="collective-purchase-modal"
        btn-primary="Перейти к оплате"
        :buttonContinueClass="continiueButtonClass"
        @success="emit('continiueBuy')"
        @cancel="emit('closePushkinWarningModal')"
        :is-enabled="isPushkinPurchaseEnable"
    >
        <template #header>
            <h4 class="pushkin-modal__title">Правила покупки с Пушкинской картой</h4>
        </template>
        <template #body>
            <div class="pushkin-modal__clause">
                <svg width="20" height="20" class="pushkin-modal__icon-alert">
                    <use xlink:href="#alert"></use>
                </svg>
                <p>Пушкинской картой может быть оплачен только один билет в рамках одного мероприятия. </p>
            </div>
            <div class="pushkin-modal__clause">
                <svg width="20" height="20" class="pushkin-modal__icon-alert">
                    <use xlink:href="#alert"></use>
                </svg>
                <p>При оплате билета Пушкинской картой, ФИО покупателя, указанные в личном кабинете, должны
                    соответствовать ФИО владельца Пушкинской карты и совпадать с данными, указанными в паспорте.</p>
            </div>
            <div class="pushkin-modal__more-info">Подробнее о правилах программы читайте <a
                    href="https://tickets.almetteatr.ru/page/page/?id=4" target="_blank">по ссылке</a>.</div>
        </template>
    </IModal>
</template>

<style>
@import '../IAcquiringsButton/i-acquirings-button.scss';
@import './pushkin-modal.scss';
</style>
